<template>
  <div
    class="ui-accordion-item"
    @click="onClick"
  >
    <div class="ui-accordion-title">
      {{ title }}
      <div v-if="$slots.title" class="ui-accordion-item__title-slot">
        <slot name="title" />
      </div>
      <chevron-animated
        v-if="!notExtendable"
        :reverse="isOpen"
      />
    </div>

    <div :class="['ui-accordion-content', {opened: isOpen}]"
      v-if="isOpen"
      @click.stop
    >
      <slot v-if="$slots.default" />
      <div v-else v-html="content" />
    </div>
  </div>
</template>

<script>
import ChevronAnimated from '../../../assets/icons/chevron-animated';

export default {
  name: 'ui-accordion-item',
  components: {
    ChevronAnimated
  },

  props: {
    itemKey: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    notExtendable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false
    }
  },

    watch: {
    '$route.hash'(hash) {
      if (!this.notExtendable && hash && this.itemKey) {
        const key = hash.slice(1); // убираем #

        if (key === this.itemKey) {
          this.isOpen = true;
          this.$el.scrollIntoView({behavior: 'smooth'});
        }
      }
    },

    notExtendable() {
      this.isOpen = false;
    }
  },

   methods: {
    onClick() {
      if (this.notExtendable) return;
       this.isOpen = !this.isOpen;
    }
  },
};
</script>

<style lang="scss">
.ui-accordion {

  &-item {
    display: flex;
    flex-direction: column;
    padding: 12px;
    border-top: 1px solid $gray_lu;

    &:last-of-type {
      border-bottom: 1px solid $gray_lu;
    }
  }

  &-title,
  &-content {
    font-size: 14px;
  }

  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 24px;
    font-weight: 600;

    & > svg {
      margin-top: 4px;
      margin-right: 4px;
      margin-left: 8px;
      min-width: 16px;
      width: 16px;
      height: 16px;
      color: $gray_lu;
    }
  }

  &-item__title-slot {
    flex: 1;
    margin-left: 20px;
    margin-right: 3px;
  }

  &-content {
    max-height: 0;
    line-height: 20px;
    overflow: hidden;
    transition: .3s max-height ease;

    & > div {
      margin-top: 12px;
    }

    &.opened {
      max-height: 10000px;
    }
  }
}

@include breakpoint("tablet") {
  .ui-accordion {
    &-title {

      & > svg {
        margin-right: 0;
      }
    }

    &-content {
      &.opened {
        max-height: 250px;
      }
    }
  }
}

@include breakpoint("desktop") {
  .ui-accordion {

    &-item {
      padding: 16px;
      cursor: pointer;
    }

    &-title,
    &-content {
      font-size: 16px;
    }

    &-title {
      & > svg {
        margin-right: 4px;
      }
    }

    &-content {
      & > div {
        margin-top: 16px;
      }
    }
  }
}
</style>